import React, { memo, useContext } from "react";
import styled from "styled-components";
import {
  GolFieldElement,
  GolContactFormContext,
} from "./gol-contact-form-interfaces";
import { GolContactErrorField } from "./gol-contact-error-field";
import { useTranslation } from "react-i18next";
import GolCountryPicker, { Country } from "./gol-country-picker";
import { makeStyles } from "@material-ui/core/styles";
const Prefix = styled.div`
  flex: 1;
  display: flex;
  @media screen and (max-width: 980px) {
    flex: 0 0 10%;
    margin-right: 8px;
  }
`;

const PhoneNumber = styled.div`
  flex: 2;
  display: flex;
  @media screen and (max-width: 980px) {
    flex: 2 0 60%;
  }
`;
const PhoneWrapper = styled.div`
  display: flex;

  input#country-select {
    min-width: 40px !important;
    margin-right: -4px;
  }
`;
const useStyles = makeStyles({
  option: {
    "MuiIconButton-label-*": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});
const GolContactPhoneField = memo((props: GolFieldElement) => {
  const { t } = useTranslation();
  const { name } = props;
  const formContext = useContext(GolContactFormContext);
  const { form, fieldsInErrors, handleFormChange, requiredFields } =
    formContext;
  const value = form[name];
  const required = requiredFields.includes(name);
  const fieldInError = fieldsInErrors.includes(name);
  const fieldFills = typeof value !== "undefined" && value != null;
  const errorMsg = fieldInError
    ? required && !fieldFills
      ? t("instabook.contacts.required_field_error")
      : t("instabook.errors.invalid_field")
    : "";
  const defaultClazzName = props.clazz ?? name;
  const clazz = fieldInError
    ? `${defaultClazzName} error`
    : `${defaultClazzName} `;
  const defaultPhoneFieldValues = {
    ...props,
    value,
    label: t(`instabook.contacts.${name}`),
    clazz,
    required,
    errorMsg,
    onChange: handleFormChange,
  } as GolFieldElement;

  const classes = useStyles();
  return (
    <PhoneWrapper className="contactField golFlexOne">
      <Prefix>
        <GolCountryPicker
          id="country-select"
          name="country_code"
          onChange={handleFormChange}
          defaultValue={form["country_code"]}
          defaultCountryError={
            fieldsInErrors.includes("country_code") === true ? "error" : ""
          }
          getOptionLabel={(option: Country) => "+" + option.phone}
          classes={{
            option: classes.option,
          }}
        />
      </Prefix>
      <PhoneNumber>
        <GolContactErrorField {...defaultPhoneFieldValues} />
      </PhoneNumber>
    </PhoneWrapper>
  );
});

export { GolContactPhoneField };
